export const scrollTo = (hash: string) => {
  const element = document.querySelector(hash);
  if (!element) return;
  const offset = document.getElementById("mainNav")?.getBoundingClientRect().height || 0;
  const top = element.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({
    top,
    behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
  });
};
